/** Fogarty Ship/Pickup options stay available after a selection. */
import CheckoutOptions from "../../../components/base/messages/CheckoutOptions.js";

export default class FogartyCheckoutOptions extends CheckoutOptions {
  _selectOption(button, buttons) {
    buttons.forEach(item => {
      item.classList.toggle("is-selected", item === button);
    });
  }
}
